import { useEffect } from 'react';
import { useUpdateNodeInternals, type NodeProps } from '@xyflow/react';
import BaseNode from './BaseNode';
import { type QuestionNodeData } from '@app/services/aiFlow.types';

function QuestionNode(props: NodeProps) {
    const { data, id } = props;
    const questionData = data as QuestionNodeData;

    const updateNodeInternals = useUpdateNodeInternals();
    useEffect(() => {
        updateNodeInternals(id);
    }, [data.visConditionSlots, data.options, id, updateNodeInternals]);

    return (
        <BaseNode
            id={id}
            type="question"
            content={questionData.text}
            visConSlots={questionData.visConditionSlots}
            options={questionData.options}
        />
    );
}

export default QuestionNode;
